// App metadata — single source of truth
export const APP_VERSION = '1.2.0';
export const APP_NAME = 'Soclean Coordinación';
export const APP_DEVELOPER = 'Leo Macaris';
export const APP_YEAR = 2026;
export const APP_COPYRIGHT = `© ${APP_YEAR} ${APP_NAME}®. Todos los derechos reservados.`;
